<template>
	<div
		:class="[
			buttonStyle ?? blok?.style,
			buttonHeight ?? blok?.height,

			'button cursor-pointer flex items-center justify-center px-5 '
		]"
	>
		<NuxtLink
			v-if="blok"
			:to="resolveLink(link || blok.button_link) || localePath('/')"
			:class="[
				blok.text_size,
				`transition-all button`,
				isButtonLink ? 'flex gap-2' : ''
			]"
		>
			{{ blok.button_text }}
			<slot />
			<ArrowLongRightIcon v-if="isButtonLink" class="w-5" />
		</NuxtLink>
		<NuxtLink
			v-else-if="link"
			:to="resolveLink(link) || localePath('/')"
			:class="[
				textSize,
				`transition-all w-full text-center button`,
				isButtonLink ? 'flex gap-2' : ''
			]"
		>
			{{ text }}
			<slot />
			<ArrowLongRightIcon v-if="isButtonLink" class="w-5" />
		</NuxtLink>
		<button
			v-else
			:class="[textSize, `transition-all w-full text-center button`]"
		>
			{{ text }}
		</button>
	</div>
</template>

<script setup lang="ts">
import type { BlokButton } from "~/types/storyblok/storyblok";
import { ArrowLongRightIcon } from "@heroicons/vue/24/outline";

interface Props {
	blok?: BlokButton;
	link?: string;
	textSize?: string;
	buttonStyle?: string;
	text?: string;
	buttonHeight?: string;
}

const { blok, link, textSize, buttonStyle, text, buttonHeight } =
	defineProps<Props>();

const localePath = useLocalePath();
const { resolveLink } = useStoryblokLink();
const isButtonLink = computed(
	() => (blok?.style || buttonStyle) === "button-link"
);
</script>
